module.exports = __webpack_public_path__ + "static/street-22f37f46ae15e0dd2335d81d94bd430c.mp4";